import styled from '@emotion/styled';

const PendingButton = styled.button`
  display: inline-flex;
  align-items: center;
  color: #7f8287;
  padding: 0;
`;

const InfoIcon = styled.span`
  border-radius: 100%;
  background-color: #c9cbcd;
  width: 14px;
  height: 14px;
  color: #fff;
  margin-left: 4px;
  font-size: 11px;
  font-weight: bold;
`;

export { PendingButton, InfoIcon };
